module.exports = __webpack_public_path__ + "static/media/safe.eaf21cfe.svg";